import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { user, register, error, setError } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Clear any stale error carried over from a previous /login attempt
  useEffect(() => { setError(""); }, [setError]);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await register(name, email, password);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F5F4F0]">
      <div className="w-full max-w-md card-soft p-8 md:p-10 fade-in-up">
        <h2 className="font-heading text-3xl font-semibold text-[#2C342A]">Create your account</h2>
        <p className="text-[#707A6E] mt-1 mb-8">Set up your family's internet hub.</p>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Name</label>
            <input
              data-testid="register-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 outline-none focus:border-[#5C7A4F]"
              required
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Email</label>
            <input
              data-testid="register-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 outline-none focus:border-[#5C7A4F]"
              required
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Password</label>
            <input
              data-testid="register-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 outline-none focus:border-[#5C7A4F]"
              required
            />
          </div>
          {error && (
            <div data-testid="register-error" className="text-sm text-[#C06E52] bg-[#C06E52]/10 rounded-xl px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="register-submit-btn"
            disabled={submitting}
            type="submit"
            className="w-full rounded-xl bg-[#5C7A4F] text-white px-6 py-3 font-medium hover:bg-[#4B6640] transition-colors disabled:opacity-60"
          >
            {submitting ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#707A6E] text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[#5C7A4F] hover:underline font-medium" data-testid="goto-login">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
